import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/i18n";
import { LangToggle } from "@/components/Navbar";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";

export default function PrivacyPage() {
  const { t, lang } = useLang();
  const sections = t("priv_sections");

  return (
    <main className="grain-overlay bg-[#0A0A0C] text-zinc-100 min-h-screen" data-testid="privacy-page">
      <Seo title={t("seo_priv_title")} description={t("seo_priv_desc")} path="/privacy" lang={lang} />
      <header className="border-b border-amber-500/10 bg-[#0D0D10]/90 sticky top-0 z-40 backdrop-blur-xl">
        <div className="px-4 sm:px-8 lg:px-16 max-w-4xl mx-auto flex items-center justify-between h-[72px]">
          <Link to="/" data-testid="privacy-logo" className="flex items-center">
            <img src="/logo.png" alt="Capital Stone — Investimenti Immobiliari" className="h-9 w-auto" />
          </Link>
          <div className="flex items-center gap-4">
            <LangToggle />
            <Link
              to="/"
              data-testid="privacy-back-link"
              className="hidden sm:flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-zinc-400 hover:text-[#D4AF37] transition-colors duration-300"
            >
              <ArrowLeft size={14} /> {t("priv_back")}
            </Link>
          </div>
        </div>
      </header>

      <div className="px-4 sm:px-8 max-w-4xl mx-auto py-16 lg:py-24">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase font-mono text-amber-400/90 mb-4">Capital Stone S.r.l.</p>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tight text-zinc-100" data-testid="privacy-title">
            {t("priv_title")}
          </h1>
          <p className="text-xs text-zinc-500 mt-4 font-mono tracking-[0.15em] uppercase">{t("priv_updated")}</p>
        </Reveal>

        <div className="mt-14 space-y-10">
          {sections.map((s, i) => (
            <Reveal key={i} delay={Math.min(i * 0.05, 0.3)}>
              <section className="border-t border-amber-500/15 pt-6" data-testid={`privacy-section-${i}`}>
                <h2 className="font-display text-xl sm:text-2xl font-semibold text-zinc-100">
                  <span className="font-mono text-sm text-[#D4AF37] mr-3">{String(i + 1).padStart(2, "0")}</span>
                  {s.h}
                </h2>
                <p className="text-sm sm:text-base text-zinc-400 leading-relaxed mt-4 whitespace-pre-line">{s.b}</p>
              </section>
            </Reveal>
          ))}
        </div>

        <div className="border-t border-white/5 mt-16 pt-8">
          <p className="text-xs text-zinc-600">
            © 2026 Capital Stone S.r.l. · P.IVA 14417030963 · REA MI-2781885 · Piazza Quattro Novembre 4, 20124 Milano
          </p>
        </div>
      </div>
    </main>
  );
}
